const publicPath = process.env.BASE_URL
const image = (path) => publicPath + 'img/' + path

const config = {
	api: {
		baseUrl_push_notif: "https://api.klinikpratamaazzahra.com/",
		baseUrl_auth: "https://api.klinikpratamaazzahra.com/api/v1/",
		baseUrl: "https://api.klinikpratamaazzahra.com/api/v1/",
		timeout: 60000
	}
}

export default (key) => {
	let path = key.split('.')
	let current = config
	for (let i = 0; i < path.length; i++) {
		if (current[path[i]] == undefined) return key
		current = current[path[i]]
	}
	return current
}
